import { PersistGate } from 'redux-persist/es/integration/react';
import './App.css';
import { Provider } from 'react-redux';
import { CssBaseline, GlobalStyles, ThemeProvider } from '@mui/material';
import store, { persistor } from './store';
import theme from './themes';
import AppRoutes from './routes';
import { SnackbarProvider } from 'notistack';
import ModalProvider from 'mui-modal-provider';
import './fonts';
import Highcharts from 'highcharts';
import HighchartsAccessibility from 'highcharts/modules/accessibility';

// Initialize Highcharts accessibility module globally so charts have proper ARIA attributes
HighchartsAccessibility(Highcharts);
Highcharts.setOptions({
  accessibility: {
    enabled: true,
    description: 'Chart',
  },
});

function App(): JSX.Element {
  return (
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <GlobalStyles styles={{
            '#app-root .MuiInputAdornment-root fieldset': {
              border: 'none !important',
              borderWidth: '0px !important',
            },
            '#app-root .MuiInputAdornment-root .Mui-focused fieldset': {
              border: 'none !important',
              borderWidth: '0px !important',
            },
            '#app-root .MuiInputAdornment-root .MuiOutlinedInput-notchedOutline': {
              border: 'none !important',
              borderWidth: '0px !important',
            },
          }} />
          <ModalProvider>
            <div id="app-root">
              <SnackbarProvider
                maxSnack={2}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}>
                <AppRoutes />
              </SnackbarProvider>
            </div>
          </ModalProvider>
        </ThemeProvider>
      </PersistGate>
    </Provider>
  );
}

export default App;
